// images
import timberBackground from "images/Timber_Splash_Background_1920x1229.png";
import { Col, Container, Row } from "components/layout";
import styled from "@emotion/styled";
import mixins from "theme/mixins";

export const StyledContainer = styled(Container)`
  padding-top: 1rem;
  padding-bottom: 1rem;
  ${mixins.media.tablet`padding-left: 1rem;
    padding-right: 1rem;`};
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const StyledRow = styled(Row)``;

export const StyledCol = styled(Col)``;

export const BlueBackground = styled.div`
  background: url(${timberBackground}) no-repeat center center fixed;
  background-size: cover;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
`;
